"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialAuthButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
require("@/components/common/button/button");
const PROVIDERS = {
    facebook: { label: '페이스북으로 시작', icon: icon_names_1.ICON_NAMES.FACEBOOK },
    google: { label: 'Google로 시작', icon: icon_names_1.ICON_NAMES.GOOGLE },
    apple: { label: 'Apple로 시작', icon: icon_names_1.ICON_NAMES.APPLE },
};
/**
 * 외부 계정으로 로그인·가입을 시작하는 버튼.
 * 레이블과 아이콘은 provider가 정하고, 인증 화면의 주 진입점이라 항상 large 크기로 컨테이너 폭을 채운다.
 */
let SocialAuthButton = class SocialAuthButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.provider = 'facebook';
    }
    render() {
        const { label, icon } = PROVIDERS[this.provider];
        return (0, lit_1.html) `
      <mm-button size="large" full-width icon=${icon}>${label}</mm-button>
    `;
    }
};
SocialAuthButton.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SocialAuthButton.prototype, "provider", void 0);
SocialAuthButton = __decorate([
    (0, decorators_js_1.customElement)('mm-social-auth-button')
], SocialAuthButton);
exports.SocialAuthButton = SocialAuthButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsLWF1dGgtYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic29jaWFsLWF1dGgtYnV0dG9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0Qsb0VBQWdFO0FBQ2hFLDZDQUEwQztBQUUxQyxNQUFNLFNBQVMsR0FBRztJQUNoQixRQUFRLEVBQUUsRUFBRSxLQUFLLEVBQUUsV0FBVyxFQUFFLElBQUksRUFBRSx1QkFBVSxDQUFDLFFBQVEsRUFBRTtJQUMzRCxNQUFNLEVBQUUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFLElBQUksRUFBRSx1QkFBVSxDQUFDLE1BQU0sRUFBRTtJQUN4RCxLQUFLLEVBQUUsRUFBRSxLQUFLLEVBQUUsV0FBVyxFQUFFLElBQUksRUFBRSx1QkFBVSxDQUFDLEtBQUssRUFBRTtDQUM3QyxDQUFBO0FBSVY7OztHQUdHO0FBRUksSUFBTSxnQkFBZ0IsR0FBdEIsTUFBTSxnQkFBaUIsU0FBUSxnQkFBVTtJQUF6Qzs7UUFNdUIsYUFBUSxHQUF1QixVQUFVLENBQUE7SUFTdkUsQ0FBQztJQVBDLE1BQU07UUFDSixNQUFNLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxHQUFHLFNBQVMsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUE7UUFFaEQsT0FBTyxJQUFBLFVBQUksRUFBQTtnREFDaUMsSUFBSSxJQUFJLEtBQUs7S0FDeEQsQ0FBQTtJQUNILENBQUM7O0FBYk0sdUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7OztHQUlsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztrREFBMEM7QUFOMUQsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyx1QkFBdUIsQ0FBQztHQUMxQixnQkFBZ0IsQ0FlNUI7QUFmWSw0Q0FBZ0IifQ==